



















































import {Component, Prop, Vue} from "vue-property-decorator";
import OverViewTable from "@/valchrom/views/dataset/OverViewTable.vue";
import JsonViewer from 'vue-json-viewer'
import DetailedView from "@/valchrom/views/dataset/DetailedView.vue";
import SeriesTabs from "@/valchrom/views/dataset/SeriesTabs.vue";
import Images from "@/valchrom/views/dataset/am/Images.vue";
import format from "@/valchrom/views/dataset/NumberFormat";

@Component({
    components: {SeriesTabs, OverViewTable, JsonViewer, DetailedView, Images},
})
export default class CCACCBHeteroContent extends Vue {
    name = 'CCACCBHeteroContent'
    @Prop() am : any;
    @Prop() analyte : any;

    anyField(obj: any) {
        for (var prop in obj) {
            if(obj.hasOwnProperty(prop)){
                return obj[prop]
            }
        }
    }

    format(val: any){
        return format(val, undefined);
    }

}
